import UploadClientAvatarMobileMenu from './upload-client-avatar-mobile-menu';

export default UploadClientAvatarMobileMenu;
